import React from 'react';

import { DEFAULT_STYLES } from '../../constants';
import { SearchIcon } from '../../icons/SearchIcon';
import { ComboBoxEmptyStateProps } from '../../types/comboBoxComponentTypes';

export const ComboBoxEmptyState: React.FC<ComboBoxEmptyStateProps> = ({
  emptyStateText,
  loadingState
}) => (
  <div className={DEFAULT_STYLES.dropdown__noResults}>
    {loadingState === 'error' ? (
      'Error loading options'
    ) : (
      <div className="flex flex-col items-center justify-center gap-2 text-base">
        <SearchIcon width={36} height={36} className="mb-2" />
        <p className="text-center font-semibold text-black">Oops... </p>
        <p className="text-center text-black text-sm">{emptyStateText}</p>
        <p className="text-center text-black text-sm">
          Click below to Add New ⬇️
        </p>
      </div>
    )}
  </div>
);

ComboBoxEmptyState.displayName = 'ComboBoxEmptyState';
